/**
 * Resultsgate API
 * Open API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Criteria { 
    analysisId?: number;
    categoryId?: number;
    country?: string;
    dateFrom?: string;
    dateTo?: string;
    resultId?: number;
    empty?: boolean;
}

